export const dataChannelLabel = 'Sorenson T.140 DC';
